module.exports = __webpack_public_path__ + "static/img/person-default.8ee872ea.png";